enum Pathnames {
	HOME = '/',
	CMS = '/c',
	FAQ = '/consulting',
	ABOUT_US = '/about-us',
	CONTACT = '/contact',
	ADMIN = '/admin'
}

export default Pathnames;
